import React, { useEffect, useMemo, useRef, useState } from 'react';
import ClassicChessboard from '../components/ClassicChessboard';
import { colour, legalMoves, toFen } from './trainingModel';

export default function LessonBoard({ board, lesson, selected, arrows, targets, onSquare, onMove, disabled }) {
  const area=useRef(null); const [size,setSize]=useState(280);
  useEffect(()=>{
    const node=area.current;
    const resize=()=>{if(node){const mobile=window.innerWidth<=768;const viewportWidth=Math.floor(window.visualViewport?.width||window.innerWidth);const width=mobile?viewportWidth:node.clientWidth;const height=node.clientHeight;setSize(Math.max(80,Math.floor(mobile?width:Math.min(width,height,720))));}};
    resize();const observer=typeof ResizeObserver!=='undefined'?new ResizeObserver(resize):null;observer?.observe(node);window.addEventListener('resize',resize);
    return()=>{observer?.disconnect();window.removeEventListener('resize',resize);};
  },[]);
  const dests=useMemo(()=>new Map(Object.keys(board).map(square=>[square,legalMoves(lesson,board,square).map(m=>m.to)])),[lesson,board]);
  const turn=lesson.turn==='w'?'white':'black';
  const config={fen:toFen(board,lesson.turn,lesson.rights,lesson.ep),orientation:'white',turnColor:turn,
    selected:selected||undefined,coordinates:true,viewOnly:disabled,
    movable:{free:false,color:turn,dests,rookCastle:false,events:{after:onMove}},
    draggable:{enabled:!disabled},selectable:{enabled:!disabled},premovable:{enabled:false},
    events:{select:square=>{if(!disabled&&board[square]&&colour(board[square])===lesson.turn)onSquare(square);}},
    highlight:{custom:new Map(targets.map(square=>[square,'lesson-target']))},
    drawable:{enabled:false,autoShapes:arrows.filter(([from])=>board[from]).map(([orig,dest])=>({orig,dest,brush:'yellow'}))}};
  return <div className="hood-board-space" ref={area}>
    <div className="hood-board-frame" style={{width:size,height:size}}>
      <ClassicChessboard config={config} label="Lesson chessboard, White at the bottom"/>
    </div>
  </div>;
}
